export { ModalComponent } from "./modal.component";
export * from "./modal.model";
export { ModalService } from "./modal.service";
